/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ActivityRole {
  Customer = "customer",
  FreightsimpleCustomerSupport = "freightsimple_customer_support",
  Insurance = "insurance",
  Carrier = "carrier",
}

export function instanceOfActivityRole(value: any): boolean {
  for (const key in ActivityRole) {
    if (Object.prototype.hasOwnProperty.call(ActivityRole, key)) {
      if (ActivityRole[key as keyof typeof ActivityRole] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ActivityRoleFromJSON(json: any): ActivityRole {
  return ActivityRoleFromJSONTyped(json, false);
}

export function ActivityRoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityRole {
  return json as ActivityRole;
}

export function ActivityRoleToJSON(value?: ActivityRole | null): any {
  return value as any;
}

export function ActivityRoleToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ActivityRole {
  return value as ActivityRole;
}
